import {usePosterProduct, usePrintProduct} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.hooks';
import type {PosterProductDataForProcessDesign} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import {Status} from '@Panels/poster-publishing-options-panel/poster-publishing-options-panel.types';
import {
  setErrorMessageForPublishingPanel,
  setShowLoader,
} from '@Panels/poster-publishing-options-panel/poster-publishing-options-slice';
import type {OrderDetailsForRedux} from '@Panels/poster-publishing-options-panel/components/publishing-embed-in-webpage-panel/publishing-embed-in-webpage-panel.types';
import type {SocialMediaResponse, WebLinkResponse} from '@Panels/poster-publishing-options-panel/components/publishing-social-media-panel/publishing-social-media-panel.types';

export const MIN_SECONDS_TO_SHOW_EMAIL_OPTION = 10;
export const MAX_ELAPSED_TIME_LENGTH = 3;

export const useProductUsed = (): PosterProductDataForProcessDesign => {
  const premiumProductDataForPoster = usePosterProduct();
  const premiumProductDataForPrint = usePrintProduct();

  return premiumProductDataForPoster && JSON.stringify(premiumProductDataForPoster) !== JSON.stringify(getDefaultPosterProductDataForProcessDesign())
    ? premiumProductDataForPoster
    : premiumProductDataForPrint;
};

export const showErrorOnPanel = (text: string): void => {
  window.PMW.redux.store.dispatch(setErrorMessageForPublishingPanel(text));
};
export const getDefaultOrderDetails = (): OrderDetailsForRedux => {
  return {
    progressPercentage: 5,
    estimatedTimeInSeconds: '',
    timeElapsedInSeconds: 0,
    error: '',
  };
};

export const showLoaderForUngeneratedOrders = (product: PosterProductDataForProcessDesign): void => {
  if (product?.status !== Status.DOWNLOADABLE) {
    window.PMW.redux.store.dispatch(setShowLoader(true));
  }
};

export function getDefaultPosterProductDataForProcessDesign(): PosterProductDataForProcessDesign {
  return {
    id: 0,
    name: '',
    description: '',
    rawPrice: 0,
    price: '',
    productPrice: 0,
    daysFree: 0,
    premiumContentAdded: false,
    retriesLeft: 0,
    creditsLeft: 0,
    productCreditPrice: 0,
    extraInfo: [],
    galleryTemplateHash: null,
    status: Status.UNDEFINED,
    orderId: '',
    purchaseId: null,
    encryptedPurchaseId: '',
    isWebDownload: false,
    orderFileURLs: [],
    downloadUrl: '',
    downloadFileUrl: '',
    isFree: false,
    hashedId: '',
    posterId: '',
    isVideo: false,
    remainingCredits: 0,
    format: '',
    maxDimension: '',
    height: 0,
    width: 0,
    hasWatermark: false,
    hasClickableLinks: false,
    isLargeSize: false,
    posterRenderId: '',
    iconClassName: '',
    needsPurchase: false,
    posterName: '',
    mimeType: '',
    needsRegenerationDueToDeletion: false,
    existingPageOrders: {},
  };
}

export function getDefaultSocialMediaLinks(): SocialMediaResponse {
  return {
    fb: '',
    tw: '',
    pt: '',
    ptUrl: '',
    posterName: '',
  };
}

export function getDefaultWebLinks(): WebLinkResponse {
  return {
    shareableUrl: '',
    isPublishedLink: false,
    isQrHostedLinkPublished: false,
    qrHostedShareableUrl: '',
    isUrlDisabled: false,
    qrTemplateHashedId: '',
    hasUserSeenQrOption: true,
    publishingCap: null,
    embedPublishingCap: null,
  };
}
